import { useState } from "react";
import AddDirectorAction from "./AddDirectorAction";
import AddDirector from "./AddDirector";
import { ICorporateCustomer } from "../../../../hooks/useCorporateCustomers";

export enum DirectorsSteps {
  ADD_DIRECTOR_ACTION = "add_director_action",
  ADD_DIRECTOR_STEPS = "add_director_steps",
}

interface ILimitedLiabilityDirectors {
  handleProceed: (step: number) => void;
  formData: any;
  resumeCustomerData?: ICorporateCustomer;
}

const LimitedLiabilityDirectors: React.FC<ILimitedLiabilityDirectors> = ({
  handleProceed,
  formData,
  resumeCustomerData,
}) => {
  const [currentStep, setCurrentStep] = useState(
    DirectorsSteps.ADD_DIRECTOR_ACTION,
  );

  const handleNextStep = (_step: DirectorsSteps) => {
    setCurrentStep(_step);
  };

  return (
    <div>
      {(() => {
        switch (currentStep) {
          case DirectorsSteps.ADD_DIRECTOR_ACTION:
            return <AddDirectorAction handleNextStep={handleNextStep} />;

          case DirectorsSteps.ADD_DIRECTOR_STEPS:
            return (
              <AddDirector
                handleProceed={handleProceed}
                formData={formData}
                resumeCustomerData={resumeCustomerData}
              />
            );

          default:
            return null;
        }
      })()}
    </div>
  );
};

export default LimitedLiabilityDirectors;
